<div class="dialog-container">
  <!-- Desktop Header: Title + Search + Close inline -->
  <div class="dialog-header-row d-none d-md-flex">
    <h1 class="dialog-title">{{ 'dialogs.select_hotel' | translate }}</h1>
    @if (permissionService.isInternal()) {
      <label class="archived-filter-checkbox">
        <input
          type="checkbox"
          [checked]="filters.only_archived"
          (change)="toggleOnlyArchived($any($event.target).checked)"
        />
        <span>{{ 'dialogs.list_all_archived_hotels' | translate }}</span>
      </label>
    }
    <div class="header-search">
      @if (isSearching) {
        <div class="search-spinner"></div>
      } @else {
        <lucide-icon name="search" class="search-icon"></lucide-icon>
      }
      <input
        #searchInput
        type="text"
        class="search-input"
        placeholder="Search a hotel..."
        (input)="onSearchInput($event)"
      />
    </div>
    <button (click)="close()" class="button-dialog-close" type="button">
      <lucide-icon name="x"></lucide-icon>
    </button>
  </div>

  <!-- Mobile Header: Back arrow + Title inline -->
  <div class="dialog-header d-md-none">
    <button (click)="close()" class="button-dialog-back" type="button">
      <lucide-icon name="arrow-left"></lucide-icon>
    </button>
    <h1 class="dialog-title">{{ 'dialogs.select_hotel' | translate }}</h1>
  </div>

  <!-- Archived-hotels filter + Search (mobile) -->
  @if (permissionService.isInternal()) {
    <div class="archived-filter-row d-md-none">
      <label class="archived-filter-checkbox">
        <input
          type="checkbox"
          [checked]="filters.only_archived"
          (change)="toggleOnlyArchived($any($event.target).checked)"
          />
        <span>{{ 'dialogs.list_all_archived_hotels' | translate }}</span>
      </label>
    </div>
  }

  <div class="search-bar d-md-none">
    <mat-form-field appearance="outline" class="search-hotel-container">
      @if (isSearching) {
        <div matPrefix class="search-spinner mobile-spinner"></div>
      } @else {
        <img
          matPrefix src="assets/images/search.svg"
          alt="{{ 'bookings.search' | translate }}"
          width="20"
          height="20"
          class="search-svg-icon"
          />
      }
      <input matInput (input)="onSearchInput($event)" placeholder="{{ 'bookings.search_hotel' | translate }}">
    </mat-form-field>
  </div>

  <div class="dialog-content" (scroll)="onScroll($event)">
    <div class="hotel-list">
      @for (hotel of filteredHotels; track hotel.id) {
        <div
          class="hotel-card"
          [class.active]="hotel.id.toString() === currentHotelId"
          (click)="onSelect(hotel.id.toString())"
          (keydown.enter)="onSelect(hotel.id.toString())"
          tabindex="0"
          role="button"
          >
          <!-- Card Top Section -->
          <div class="card-top">
            <!-- Header Row: Status + Actions -->
            <div class="card-header-row d-flex justify-content-start align-items-center">
              @if (hotel.is_archived) {
                <hc-badge color="warning" size="small" variant="light" [dispIcon]="true">
                  <lucide-icon badgeIcon name="archive" class="icon-sm" aria-hidden="true"></lucide-icon>
                  {{ 'dialogs.archived_badge' | translate }}
                </hc-badge>
              } @else {
                <span
                  class="status-badge"
                  [ngClass]="{
                    'status-published': hotel['hotel_status'] === 1,
                    'status-hidden': hotel['hotel_status'] === 2,
                    'status-offline': hotel['hotel_status'] === 0
                  }"
                  >
                  @switch (hotel?.['hotel_status']) {
                    @case (1) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M6.74475 2.91675C3.67678 2.91675 1.74768 5.80846 1.16663 7.25529C1.74768 8.70211 3.67678 11.5938 6.74475 11.5938C9.81272 11.5938 11.7418 8.70211 12.3229 7.25529C11.7418 5.80846 9.81272 2.91675 6.74475 2.91675ZM3.95569 7.25529C3.95569 6.51558 4.24954 5.80617 4.77259 5.28312C5.29564 4.76007 6.00505 4.46623 6.74475 4.46623C7.48446 4.46623 8.19386 4.76007 8.71692 5.28312C9.23997 5.80617 9.53381 6.51558 9.53381 7.25529C9.53381 7.99499 9.23997 8.7044 8.71692 9.22745C8.19386 9.7505 7.48446 10.0444 6.74475 10.0444C6.00505 10.0444 5.29564 9.7505 4.77259 9.22745C4.24954 8.7044 3.95569 7.99499 3.95569 7.25529ZM4.88538 7.25529C4.88538 8.28182 5.71822 9.11466 6.74475 9.11466C7.77128 9.11466 8.60413 8.28182 8.60413 7.25529C8.60413 6.22876 7.77128 5.39591 6.74475 5.39591C6.62079 5.39591 6.49877 5.40754 6.38062 5.43078L6.74475 7.25529L4.92024 6.89116C4.897 7.00931 4.88538 7.13133 4.88538 7.25529Z" fill="#2A3348"/>
                      </svg>
                    }
                    @case (2) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M1.52081 2.61797L1.15281 2.33325L0.583374 3.06732L0.951375 3.35203L12.0398 11.9613L12.4078 12.246L12.9773 11.512L12.6093 11.2273L10.7325 9.77075C11.544 8.91854 12.0921 7.95205 12.3594 7.28965C11.7784 5.84282 9.84926 2.95111 6.78129 2.95111C5.48554 2.95111 4.39509 3.46631 3.52157 4.17132L1.52081 2.61797ZM4.89286 5.23659C5.3887 4.77949 6.05304 4.50059 6.78129 4.50059C8.32109 4.50059 9.57035 5.74985 9.57035 7.28965C9.57035 7.76805 9.45027 8.2174 9.23915 8.61058L8.48959 8.02759C8.58837 7.80098 8.6426 7.55112 8.6426 7.28965C8.6426 6.26312 7.80976 5.43027 6.78323 5.43027C6.65927 5.43027 6.53725 5.44189 6.4191 5.46514L6.64377 6.59238L4.89286 5.23659ZM9.20042 10.9813L7.80782 9.88309C7.49018 10.009 7.14348 10.0787 6.78129 10.0787C5.2415 10.0787 3.99223 8.82944 3.99223 7.28965C3.99223 7.15601 4.00191 7.02624 4.01934 6.89841L2.24325 5.49806C1.74936 6.14884 1.39879 6.80156 1.20317 7.28965C1.78422 8.73647 3.71332 11.6282 6.78129 11.6282C7.68967 11.6282 8.49734 11.3745 9.20042 10.9813ZM6.87426 9.14709L4.95484 7.63441C5.1156 8.4963 5.87291 9.14902 6.78129 9.14902C6.81228 9.14902 6.84327 9.14902 6.87426 9.14709Z" fill="#858EA4"/>
                      </svg>
                    }
                    @case (0) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M10.8416 4.31145C11.1605 3.99258 11.1605 3.47475 10.8416 3.15589C10.5227 2.83703 10.0049 2.83703 9.68604 3.15589L6.99996 5.84453L4.31132 3.15844C3.99246 2.83958 3.47463 2.83958 3.15577 3.15844C2.83691 3.47731 2.83691 3.99514 3.15577 4.314L5.84441 7.00008L3.15832 9.68872C2.83946 10.0076 2.83946 10.5254 3.15832 10.8443C3.47718 11.1631 3.99501 11.1631 4.31387 10.8443L6.99996 8.15563L9.68859 10.8417C10.0075 11.1606 10.5253 11.1606 10.8441 10.8417C11.163 10.5229 11.163 10.005 10.8441 9.68616L8.15551 7.00008L10.8416 4.31145Z" fill="white"/>
                      </svg>
                    }
                  }
                  {{ getStatusLabel(hotel?.['hotel_status'] ?? 0) }}

                </span>
              }
              @if (hotel?.channel_settings?.['channel_manager_id']) {
                <span class="channel-manager-badge d-flex justify-content-center align-items-center">
                  <!-- <i class="mdi mdi-paperclip"></i> -->
                  <img src="assets/icons/link.svg" alt="CM" class="channel-manager-icon">
                  <span>CM</span>
                </span>
              }
            </div>
            <div class="card-actions d-flex justify-content-end align-items-center">
                <!-- Completeness indicator -->
                <div class="completeness">
                    <div class="completeness-ring" [ngClass]="getCompletenessClass(hotel.completeness_percentage)">
                      <svg viewBox="0 0 28 28" width="28" height="28">
                        <circle cx="14" cy="14" r="12" fill="none" stroke="#E3E4E8" stroke-width="2.5"/>
                        <circle cx="14" cy="14" r="12" fill="none" stroke-width="2.5" stroke-linecap="round"
                          [attr.stroke-dasharray]="75.4"
                          [attr.stroke-dashoffset]="75.4 - (75.4 * hotel.completeness_percentage / 100)"
                          transform="rotate(-90 14 14)"/>
                      </svg>
                      <span class="percentage-text">{{ hotel.completeness_percentage }}%</span>
                    </div>
                </div>
              </div>

            <!-- Hotel Name -->
            <h2 class="hotel-name">{{ hotel.name }}</h2>

            <!-- Star Rating / Swiss Lodge / Not Classified -->
            <div class="rating-row">
              @if (hotel.rating === '6') {
                <span class="swiss-lodge-badge">{{ 'dialogs.swiss_lodge' | translate }}</span>
              } @else if (hotel.rating && hotel.rating !== 'no_rating' && parseInt(hotel.rating, 10) >= 1 && parseInt(hotel.rating, 10) <= 5) {
                <div class="stars">
                  @for (star of [].constructor(parseInt(hotel.rating, 10)); track $index) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                      <path d="M7.03553 1.61804L8.03749 4.70054L8.14044 5.01656H8.47329H11.7126L9.09167 6.92139L8.82342 7.11624L8.92637 7.43226L9.92833 10.5148L7.30742 8.60991L7.03917 8.41506L6.77092 8.60991L4.15001 10.5148L5.15197 7.43226L5.25493 7.11624L4.98668 6.92139L2.36577 5.01656H5.60506H5.9379L6.04086 4.70054L7.04282 1.61804H7.03553Z" fill="#FBB041" stroke="#FBB041"/>
                    </svg>
                  }
                </div>
              } @else {
                <span class="no-rating-text">{{ 'dialogs.no_rating' | translate }}</span>
              }
            </div>
          </div>

          <!-- Image Section -->
          <div class="card-image">
            @if (hotel.image) {
              <img [src]="hotel.image" (error)="onImageError($event)" alt="{{ hotel.name }}">
            } @else {
              <div class="image-placeholder">
                <app-avatar-initial [name]="hotel.name" size="lg"></app-avatar-initial>
              </div>
            }
            @if (hotel['hide_hotel'] === 1) {
              <div class="image-overlay"></div>
            }
            <button type="button" class="view-hotel-btn" (click)="onSelect(hotel.id.toString())">
              View hotel
            </button>
          </div>

          <!-- Footer Action Buttons -->
          <div class="card-footer">
            <button type="button" class="action-btn" (click)="goToBookings(hotel.id, $event)">
              Bookings
              @if (hotel?.['pending_count'] && hotel?.['pending_count']! > 0) {
                <span class="action-badge">{{ hotel?.['pending_count'] }}</span>
              }
            </button>
            <button type="button" class="action-btn" (click)="goToAvailability(hotel.id, $event)">
              Availability
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Empty state when no results -->
    @if (filteredHotels.length === 0 && !loading && !isSearching && searchTerm) {
      <app-empty-state
        iconType="feather"
        icon="search"
        title="No hotels found"
        [description]="'No hotels match &quot;' + searchTerm + '&quot;'">
      </app-empty-state>
    }
    @if (loading) {
      <div class="loading-spinner">
        <div class="global-spinner">
          <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z" fill="#D04343"/>
            <path class="ring" d="M24 6.96C21.7622 6.96 19.5464 7.40075 17.479 8.25709C15.4116 9.11343 13.5332 10.3686 11.9509 11.9509C10.3685 13.5332 9.11339 15.4117 8.25705 17.4791C7.40071 19.5465 6.95996 21.7623 6.95996 24C6.95996 26.2377 7.40071 28.4535 8.25705 30.5209C9.11339 32.5883 10.3685 34.4668 11.9509 36.0491C13.5332 37.6314 15.4116 38.8866 17.479 39.7429C19.5464 40.5992 21.7622 41.04 24 41.04C26.2377 41.04 28.4535 40.5992 30.5209 39.7429C32.5883 38.8866 34.4667 37.6314 36.0491 36.0491C37.2504 34.8477 38.2632 33.4756 39.056 31.9797L41.6007 33.3284C40.6739 35.0771 39.4899 36.6811 38.0855 38.0856C36.2358 39.9353 34.0398 41.4026 31.623 42.4037C29.2062 43.4048 26.6159 43.92 24 43.92C21.384 43.92 18.7937 43.4048 16.3769 42.4037C13.9601 41.4026 11.7641 39.9353 9.91439 38.0856C8.06465 36.2358 6.59735 34.0399 5.59628 31.6231C4.5952 29.2062 4.07996 26.6159 4.07996 24C4.07996 21.3841 4.5952 18.7938 5.59628 16.3769C6.59735 13.9601 8.06465 11.7642 9.91439 9.91443C11.7641 8.06469 13.9601 6.59739 16.3769 5.59632C18.7937 4.59525 21.384 4.08 24 4.08C26.6159 4.08 29.2062 4.59525 31.623 5.59632C34.0398 6.5974 36.2358 8.06469 38.0855 9.91444C39.4899 11.3189 40.6739 12.9229 41.6007 14.6716L39.056 16.0203C38.2632 14.5244 37.2504 13.1523 36.0491 11.9509C34.4667 10.3686 32.5883 9.11344 30.5209 8.2571C28.4535 7.40075 26.2377 6.96 24 6.96Z" fill="white"/>
            <path d="M17.1676 13.5959C17.5398 13.8669 17.76 14.2996 17.76 14.76V25.0907C19.5278 25.6327 21.6715 25.92 24 25.92C26.4148 25.92 28.4576 25.6955 30.24 25.2931L30.24 13.44H33.12L33.12 24.4147C34.7506 23.7755 36.1557 22.962 37.4744 22.0321L39.1341 24.3857C37.3449 25.6474 35.4136 26.7107 33.12 27.4774V34.56H30.24V28.2367C28.4065 28.6009 26.352 28.8 24 28.8C21.8146 28.8 19.6781 28.5698 17.76 28.0807V34.56H14.88V27.0622C14.7819 27.0156 14.685 26.9681 14.5892 26.9196C12.0098 25.6129 10.08 23.4627 10.08 20.4C10.08 18.3125 11.5031 14.8008 15.8779 13.3895C16.3161 13.2482 16.7954 13.3249 17.1676 13.5959ZM14.88 23.7485V17.0747C13.3754 18.188 12.96 19.6729 12.96 20.4C12.96 21.7125 13.5857 22.8355 14.88 23.7485Z" fill="white"/>
          </svg>
        </div>
      </div>
    }
  </div>
</div>
